import Chip, { ChipProps } from '@mui/material/Chip'
import { styled } from '@mui/material/styles'

const BaseChip = styled(Chip)({
  gap: '0.5rem', // spacing between icon and label
  fontWeight: 600,
  '& .MuiChip-icon': { fontSize: '1em', padding: '0.1rem' },
})

export const ButtonChip = (props: Omit<ChipProps, 'variant'>): JSX.Element => {
  return <BaseChip variant='subtle' {...props} />
}
